module.exports = __webpack_public_path__ + "img/action-btn-1.7cc7beb8.png";